import { InventoryManagementSearchCriteria } from 'remarketing-angular-library';

// attributes that the siderail and utility bar filters modifies
export type InventoryManagementFilterConfiguration = Pick<InventoryManagementSearchCriteria,
  'sortBy' |
  'sortOrder' |
  'filterByStatus' |
  'filterByReposted' |
  'filterByOfferLists' |
  'filterByDealer' |
  'filterByBids' |
  'filterByEmployeeDealerMap' |
  'dealersMadeOffers' |
  'dealersAskedQuestions' |
  'dateRange' |
  'dealersMadeOffersBids' |
  'dealersWonVehicles' |
  'dealersWithCounterOffers' |
  'offerListCreators' |
  'offerLists' |
  'tenantUuid' |
  'reservedForDealers' |
  'reservedByUsers' |
  'grounded' |
  'filterByInService'
>;

export const filterParameters = [
  'sortBy',
  'sortOrder',
  'filterByStatus',
  'filterByReposted',
  'filterByOfferLists',
  'filterByDealer',
  'filterByBids',
  'filterByEmployeeDealerMap',
  'dealersMadeOffers',
  'dealersAskedQuestions',
  'dateRange',
  'dealersMadeOffersBids',
  'dealersWonVehicles',
  'dealersWithCounterOffers',
  'offerListCreators',
  'offerLists',
  'tenantUuid',
  'reservedForDealers',
  'reservedByUsers',
  'grounded',
  'filterByInService',
];
